import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldFeedBoardAssoc']),
        getByBoardMessage: state => idMessage => {
            return state.objs.filter(assoc => assoc.boardMessage === idMessage);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldFeedBoardAssoc'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldFeedBoardAssoc'])
    },
}